import styled, { css } from "styled-components";
// import { colors } from "../../utils";
import { colors } from "../../utils";
import { TextView } from "@components";
import { mq } from "../../utils/breakpoints";

export const Container = styled.div`
  height: 8vh;
  width: 100%;
  background-color: ${colors.background};
  display: grid;
  grid-template-columns: 40% 20% 40%;
  box-shadow: 0px 4px 7px 0px #00000014;
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const CenterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Logo = styled.img`
  height: 6vh;
  width: 6vh;
  margin-left: 3vw;
  margin-right: 3vw;
  cursor: pointer;
`;

export const SearchBar = styled.div`
  text-align: left;
`;

export const CreateWheelContainer = styled.div`
  position: absolute;
  top: 0;
  border: 10px solid ${colors.background};
  background-color: ${colors.background};
  border-radius: 50%;
  height: 10vh;
  width: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0px 13px 8px -5px #00000014;
  cursor: pointer;
`;

export const InviteContainer = styled.div`
  text-align: center;
  background-color: ${colors.primary};
  color: ${colors.white};
  font-size: 14px;
  cursor: pointer;
  width: 140px;
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin-right: 1vw;
`;

export const FeedbackIcon = styled.img`
  height: 24px;
  width: 24px;
  margin-right: 5px;
`;
export const UserContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 5px;
  padding-bottom: 5px;
  margin-left: 10px;
  /* Give the 46px WheelComponent a real containing block. Without this,
     percentage width/height on the avatar collapse to 0 on View Wheel. */
  min-width: 46px;
  min-height: 46px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  /* A7 (a11y): the avatar is a keyboard-operable menu trigger (role="button").
     Give it a visible focus ring for keyboard users (WCAG 2.4.7); :focus-visible
     only so a pointer click never paints the ring. */
  &:focus-visible {
    outline: 2px solid ${colors.PrimaryPurple500};
    outline-offset: 2px;
  }
`;

export const CreateWheelImage = styled.img`
  background-color: ${colors.background};
  width: 100%;
  height: 100%;
`;

export const LoggingOut = styled(TextView)`
  display: inline-block;
  clip-path: inset(0 4ch 0 0);
  animation: l 1s steps(4) infinite;
  font-weight: 700;
`;

export const ButtonView = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
`;

export const Button = styled.div`
  width: 90px;
  height: 4vh;
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: ${colors.lightBlue};
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  background-color: ${colors.white};
  min-width: 160px;
  top: 7vh;
  box-shadow: 0px 4px 7px 0px #00000014;
  border-radius: 5px;
  padding: 5px;
  left: -140px;
  z-index: 999999999999999999999999;
  ${(props) =>
    props.clicked &&
    `
      background-color: ${colors.lightBlue};
    `}

  &:hover {
    cursor: pointer;
  }

  /* freeze-reverify-acct-switcher-mobile-popover-overflow: the constant
     left:-140px anchor above is tuned for desktop's wide gap to the avatar's
     left. At phone widths the avatar sits close enough to the viewport edge
     that -140px still isn't far enough left for the dropdown's real content
     width, so its right edge spills past the viewport (measured 46px past
     390px live). Anchoring to the container's own right edge instead means
     it can never extend further right than the avatar itself, which is
     already on-screen. */
  ${mq.phone} {
    left: auto;
    right: 0;
  }
`;

export const DropdownItem = styled.div`
  text-align: left;
  height: 34px;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 10px;
  color: black;
  border-radius: 4px;
  background-color: ${(props) =>
    props.isActive ? colors.PrimaryPurple100 : "transparent"};
  &:hover {
    background-color: ${colors.PrimaryPurple100};
  }
`;

export const DropdownImage = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 10px;
`;

export const DropdownImage2 = styled.img`
  width: 17px;
  height: 17px;
  margin-right: 8.5px;
  margin-left: -2px;
`;

export const DropdownImage3 = styled.img`
  width: 19px;
  height: 19px;
  margin-right: 7px;
  margin-left: -2px;
`;

export const WrapperMainDiv = styled.div`
  width: 30vw;
  height: 92vh;
  overflow-y: auto;
  background-color: white;
  // z-index: 1000;
  border-radius: 4px;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  padding: 24px 16px 0px 16px;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(1px);
    `}
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.lightBorder};
`;
